// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Base_Url } from '../config';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import "./allnews.css"
// import { FaEdit, FaPlus, FaTrash, FaCalendar } from 'react-icons/fa';

// const NewsAndAnnouncements = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   const userfromwebmaster = useSelector((state) => state.user);
//   const statecsc = useSelector((state) => state.statecsc);

//   const fetchNews = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/newsandannouncement`);
//       setNews(response.data);
//       setLoading(false);
//     } catch (err) {
//       setError('Failed to fetch news and announcements');
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNews();
//   }, []);

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this news item?')) {
//       return;
//     }
//     try {
//       await axios.delete(`${Base_Url}/newsandannouncement/${id}`);
//       alert('News deleted successfully!');
//       fetchNews();
//     } catch (err) {
//       setError('Failed to delete news');
//       console.error('Error deleting news:', err);
//     }
//   };

//   const renderLink = (item) => {
//     if (item.internal_link) {
//       return (
//         <Link to={item.internal_link} className="text-start">
//           <button className="read-more-btn">
//             <div className="d-flex align-items-center">
//               <span style={{ fontSize: "13px" }}>View More</span>
//             </div>
//           </button>
//         </Link>
//       );
//     } else if (item.external_link) {
//       return (
//         <a
//           href={item.external_link}
//           target="_blank"
//           rel="noopener noreferrer"
//           className="text-start"
//         >
//           <button className="read-more-btn">
//             <div className="d-flex align-items-center">
//               <span style={{ fontSize: "13px" }}>View More</span>
//             </div>
//           </button>
//         </a>
//       );
//     }
//     return null;
//   };

//   if (loading) {
//     return (
//       <div className="spinner-container">
//         <div className="spinner-border text-danger" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="alert alert-danger" role="alert">
//         {error}
//       </div>
//     );
//   }

//   return (
//     <div className="container main-container">
//       <div className="header-section">
//       <h1 className="alumni-title text-uppercase mt-4 mb-4 d-flex align-items-center justify-content-center">
//           <span style={{ color: "#686464" }}>News & </span>&nbsp;Announcements


//           {/* <div className="ms-3 d-flex gap-2">
//             <Link to="/handlenewsannouncement" style={{ color: '#c21717', cursor: 'pointer' }}>
//               <FaPlus size={24} className="hover-effect" />
//             </Link>
//           </div> */}
//         </h1>
//         {(userfromwebmaster.userExists || statecsc.userState === 0) && (
//           <Link to="/handlenewsannouncement" className="add-news-btn">
//             <FaPlus />
//           </Link>
//         )}
//       </div>


//       <div className="news-cards">
//         {news?.map((item) => (
//           <div key={item.id} className="news-card">
//             <div className="news-card-inner">
//               <div className="news-image-container">
//                 <img
//                   src={`${Base_Url}/${item.image_path}`}
//                   className="news-image"
//                   alt={item.title}
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src = '/placeholder-image.jpg';
//                   }}
//                 />
//               </div>

//               <div className="news-content">
//                 <div className="news-header">
//                   <h2 className="news-title">{item.title}</h2>
//                   {(userfromwebmaster.userExists || statecsc.userState === 0) && (
//                     <div className="admin-controls">
//                       <Link 
//                         to={`/handlenewsannouncement/${item.id}`}
//                         className="edit-btn"
//                       >
//                         <FaEdit />
//                       </Link>
//                       <button
//                         onClick={() => handleDelete(item.id)}
//                         className="delete-btn"
//                       >
//                         <FaTrash />
//                       </button>
//                     </div>
//                   )}
//                 </div>
//                 <p className="news-description">{item.description}</p>
//                 {renderLink(item)}
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default NewsAndAnnouncements;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Base_Url } from '../config';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import "./allnews.css"
import { FaEdit, FaPlus, FaTrash, FaCalendar } from 'react-icons/fa';

const NewsAndAnnouncements = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userfromwebmaster = useSelector((state) => state.user);
  const statecsc = useSelector((state) => state.statecsc);

  const fetchNews = async () => {
    try {
      const response = await axios.get(`${Base_Url}/newsandannouncement`);
      setNews(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch news and announcements');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this news item?')) {
      return;
    }
    try {
      await axios.delete(`${Base_Url}/newsandannouncement/${id}`);
      alert('News deleted successfully!');
      fetchNews();
    } catch (err) {
      setError('Failed to delete news');
      console.error('Error deleting news:', err);
    }
  };

  const renderLink = (item) => {
    if (item.internal_link) {
      return (
        <Link to={item.internal_link} className="text-start">
          <button className="read-more-btn">
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "13px" }}>View More</span>
            </div>
          </button>
        </Link>
      );
    } else if (item.external_link) {
      return (
        <a
          href={item.external_link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-start"
        >
          <button className="read-more-btn">
            <div className="d-flex align-items-center">
              <span style={{ fontSize: "13px" }}>View More</span>
            </div>
          </button>
        </a>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  const isAdmin = userfromwebmaster.userExists || statecsc.userState === 0;
  const hasNews = news.length > 0;

  return (
    <div className="container main-container">
      {(hasNews || isAdmin) && (
        <div className="header-section">
          <h1 className="alumni-title text-uppercase mt-4 mb-4 d-flex align-items-center justify-content-center">
            <span style={{ color: "#686464" }}>News & </span>&nbsp;Announcements
          </h1>
          {isAdmin && (
            <Link to="/handlenewsannouncement" className="add-news-btn">
              <FaPlus />
            </Link>
          )}
        </div>
      )}

      {hasNews ? (
        <div className="news-cards">
          {news?.map((item) => (
            <div key={item.id} className="news-card">
              <div className="news-card-inner">
                <div className="news-image-container">
                  <img
                    src={`${Base_Url}/${item.image_path}`}
                    className="news-image"
                    alt={item.title}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/placeholder-image.jpg';
                    }}
                  />
                </div>

                <div className="news-content">
                  <div className="news-header">
                    <h2 className="news-title">{item.title}</h2>
                    {isAdmin && (
                      <div className="admin-controls">
                        <Link 
                          to={`/handlenewsannouncement/${item.id}`}
                          className="edit-btn"
                        >
                          <FaEdit />
                        </Link>
                        <button
                          onClick={() => handleDelete(item.id)}
                          className="delete-btn"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    )}
                  </div>
                  <p className="news-description">{item.description}</p>
                  {renderLink(item)}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        !isAdmin && (
          <div className="text-center py-5">
            <p>No news and announcements available at the moment.</p>
          </div>
        )
      )}
    </div>
  );
};

export default NewsAndAnnouncements;